import { useCallback, useMemo } from "react";
import type { DashboardBlockModelT } from "../../schema/dashboard";
import { useDashboardEditorContext } from "../context/editor";
import { useDashboardEditorState } from "../store/editor";

export function useSwapBlockCallback(
  block: DashboardBlockModelT | undefined,
  direction: "up" | "down",
) {
  const editor = useDashboardEditorContext();
  const editorState = useDashboardEditorState(editor?.store);

  const siblingBlock = useMemo(() => {
    if (!block) return null;
    switch (direction) {
      case "up":
        return editorState?.blocks.find(b => b.position[1] === block.position[1] - 1);
      case "down":
        return editorState?.blocks.find(b => b.position[1] === block.position[1] + 1);
      default:
        return null;
    }
  }, [block, direction, editorState?.blocks]);

  const swapBlock = useCallback(() => {
    if (!siblingBlock || !block) return;
    void editor?.updateManyBlocks([
      { ...block, position: siblingBlock.position },
      { ...siblingBlock, position: block.position },
    ]);
  }, [block, editor, siblingBlock]);

  return useMemo(() => ({ siblingBlock, swapBlock }), [siblingBlock, swapBlock]);
}
